import React, { FC, Fragment, useState } from 'react';
import { formatDate } from 'utils/format';
import { useTranslation } from 'react-i18next';
import { InvoicingState, Order } from 'models/order';
import { Alert, Box, Typography, Tooltip, IconButton } from '@mui/material';
import InvoiceStateModule from 'components/orders/order-details/invoice-state-module.component';
import EditIcon from '@mui/icons-material/Edit';
import ChangeReadyToInvoiceDateDialog from './change-ready-to-invoice-date-dialog.component';

type OrderInvoiceStateButtonsProps = {
    order: Order;
    invoiceState: string;
    onChangeInvoice: (value: string) => void;
};
const OrderInvoiceStateButtons: FC<OrderInvoiceStateButtonsProps> = ({
    order,
    invoiceState,
    onChangeInvoice,
}: OrderInvoiceStateButtonsProps) => {
    const { t: translate } = useTranslation(['orders', 'invoices']);
    const [readyForInvoiceDateDialogOpen, setReadyForInvoiceDateDialogOpen] = useState(false);

    return (
        <Fragment>
            <InvoiceStateModule invoiceState={invoiceState} onChangeInvoice={onChangeInvoice} order={order} />
            {order.invoiceActionTime && invoiceState === InvoicingState.READY_FOR_INVOICE ? (
                <Box mb={2} mt={2}>
                    <Typography variant="subtitle2">{translate('invoices:READY_FOR_INVOICE_DATE')}</Typography>
                    <Box>
                        {formatDate(order.invoiceActionTime, 'date')}
                        <Tooltip title={translate('invoices:EDIT_READY_FOR_INVOICE_DATE').toString()}>
                            <IconButton
                                onClick={() => setReadyForInvoiceDateDialogOpen(true)}
                                size="small"
                                color="primary"
                                data-test="order-info-section.edit-ready-for-invoice-date-btn"
                            >
                                <EditIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
            ) : undefined}
            {!order?.deliveryDetails?.price || order?.deliveryDetails?.price === 0 ? (
                <Box>
                    <Alert severity="info" sx={{ border: 0 }}>
                        {translate('orders:ZERO_PRICE_ORDER')}
                    </Alert>
                </Box>
            ) : undefined}
            <ChangeReadyToInvoiceDateDialog
                open={readyForInvoiceDateDialogOpen}
                order={order}
                onClose={() => setReadyForInvoiceDateDialogOpen(false)}
            />
        </Fragment>
    );
};

export default OrderInvoiceStateButtons;
